import { Message, Loading } from 'element-ui';
import axios from "axios";
import router from '@/router';
import { AUTHORIZATION, BEARER } from "@/constant/Const";
import Vue from 'vue'
let vm = new Vue()

let loadingInstance = null; // 定义一个 loading 实例

//请求拦截器
axios.interceptors.request.use(function (config) {
    const token = window.sessionStorage.getItem("token");
    if (token) {
        config.headers[AUTHORIZATION] = BEARER + token;
    }

    // 判断是否需要 loading
    if (config.showLoading) {
        loadingInstance = Loading.service({
            lock: true,
            text: '加载中...',
            background: 'rgba(0, 0, 0, 0.3)'
        });
    }

    return config;
}, function (error) {
    if (loadingInstance) loadingInstance.close();
    return Promise.reject(error);
})

// 响应拦截器
axios.interceptors.response.use(function (resp) {
    if (loadingInstance) {
        loadingInstance.close();
        loadingInstance = null;
    }

    if (resp.data) {
        if (resp.data.msg) {
            if (resp.data.code == '0' || resp.data.code == "1") {
                Message.success({ message: resp.data.msg });
            } else if (resp.data.code == '403') {
                window.sessionStorage.removeItem('token');
                window.sessionStorage.removeItem('userInfo');
                window.sessionStorage.removeItem('menuList');
                Message.error({ message: '权限不足，请重新登录！' });
                router.replace('/login');
            } else {
                console.log(resp.config.url);
                // if(resp.config.url.indexOf("/api/crm/district/applyDistrict")!=-1){
                    Message.error({ message: resp.data.msg });
                // }
            }
        }
    }
    setTimeout(() => {
        vm.$translate.execute()
    }, 100)
    return resp.data;
}, function (error) {
    if (loadingInstance) {
        loadingInstance.close();
        loadingInstance = null;
    }

    if (error.response) {
        if (error.response.status === 504 || error.response.status === 404) {
            Message.error({ message: '服务找不到...' });
        } else if (error.response.status === 403) {
            window.sessionStorage.removeItem('token');
            window.sessionStorage.removeItem('userInfo');
            window.sessionStorage.removeItem('menuList');
            Message.error({ message: '权限不足，请联系管理员！' });
            router.replace('/login');
        } else if (error.response.status === 401) {
            window.sessionStorage.removeItem('token');
            window.sessionStorage.removeItem('userInfo');
            window.sessionStorage.removeItem('menuList');
            Message.error({ message: '尚未登录，请登录！' });
            router.replace('/login');
        } else {
            if (error.response.data.msg) {
                Message.error({ message: error.response.data.msg });
            } else {
                Message.error({ message: '未知错误！' });
            }
        }
    } else {
        Message.error({ message: '网络错误或服务器没有响应！' });
    }
    return Promise.reject(error);
});


let base = '';
export const getRequest = (url, params, showLoading = false) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params,
        showLoading
    })
}

export const getRequestRestFul = (url, showLoading = false) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        showLoading
    })
}

export const postRequest = (url, params, showLoading = false) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        showLoading
    })
}

export const deleteRequest = (url, params, showLoading = false) => {
    return axios({
        method: 'delete',
        url: `${base}${url}`,
        data: params,
        showLoading
    })
}

export const putRequest = (url, params, showLoading = false) => {
    return axios({
        method: 'put',
        url: `${base}${url}`,
        data: params,
        showLoading
    })
}

export const downPostRequest = (url, params, showLoading = true) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        responseType: 'blob',
        showLoading
    })
}
